'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _svg = require('../../utils/svg.utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var controls = (0, _svg.getSvgControls)();
var Svg = controls.Svg,
    Path = controls.Path;

var Light = function (_React$Component) {
    _inherits(Light, _React$Component);

    function Light() {
        _classCallCheck(this, Light);

        return _possibleConstructorReturn(this, (Light.__proto__ || Object.getPrototypeOf(Light)).apply(this, arguments));
    }

    _createClass(Light, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                Svg,
                { width: '26', height: '32', viewBox: '0 0 26 32' },
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M17.46 23.22c-.173 2.998-2.658 5.375-5.7 5.375s-5.525-2.377-5.7-5.374H2.72c-1.856 0-2.72-1.758-1.593-3.224l5.49-7.137c.48-.625 1.363-1.058 2.148-1.058h.645V9.114c0-.74.596-1.342 1.342-1.342h.673V4.078c0-.37.3-.672.672-.672s.672.3.672.672v3.694h.672c.74 0 1.342.596 1.342 1.342v2.688h.695c.79 0 1.663.428 2.147 1.057l5.49 7.136c1.132 1.472.267 3.225-1.592 3.225H17.46zm-6.706-11.417c0 .002 2.688 0 2.688 0 .002 0 0-2.69 0-2.69l-2.69.002.002 2.688zm-8.562 9.012c-.446.58-.215 1.062.528 1.062h18.806c.747 0 .98-.475.528-1.062l-5.49-7.137c-.23-.3-.712-.533-1.083-.533H8.768c-.367 0-.857.24-1.083.533l-5.49 7.137zm5.203 2.43c.193 2.232 2.083 4.006 4.366 4.006 2.29 0 4.184-1.763 4.367-4.006 0 0-8.733-.006-8.732 0z' }),
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M25.594 23.465h-25.594v-0.533c0-6.612 5.759-11.997 12.797-11.997s12.797 5.385 12.797 11.997v0.533zM1.066 22.398h23.461c-0.32-5.759-5.439-10.398-11.731-10.398s-11.411 4.639-11.731 10.398z' }),
                _react2.default.createElement(Path, { fill: this.props.fill, d: 'M12.264 3.47h1.066v7.998h-1.066v-7.998z' }),
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M12.797 28.53c-2.933 0-5.332-2.239-5.332-5.012 0-0.16 0-0.267 0.053-0.427 0-0.053 0-0.107 0-0.16v-0.533h10.451l0.107 0.427c0.053 0.267 0.053 0.48 0.053 0.693 0 2.773-2.399 5.012-5.332 5.012zM8.531 23.465c0 0 0 0.053 0 0 0 2.239 1.92 3.999 4.266 3.999s4.266-1.76 4.266-3.946c0 0 0-0.053 0-0.053h-8.531z' })
            );
        }
    }]);

    return Light;
}(_react2.default.Component);

Light.propTypes = {
    fill: _react2.default.PropTypes.string
};

exports.default = Light;


//////////////////
// WEBPACK FOOTER
// ./~/pluton-assets/lib/icons/svg/light.js
// module id = 1111
// module chunks = 0